<template>
    <nav
        v-if="list"
        :class="[
            'nav-mobile',
            { 'nav-mobile--opened' : navOpened }
        ]"
    >
        <a
            href="#"
            class="nav-mobile__toggle"
            @click.prevent="toggleNav"
        >
            <z-icon
                width="42"
                height="42"
                name="burger"
                v-show="!navOpened"
                :color="menuInvert ? 'white' : ''"
            ></z-icon>
            <z-icon
                width="24"
                height="24"
                name="close"
                v-show="navOpened"
            ></z-icon>
        </a>

        <div class="nav-mobile__container" v-show="navOpened">
            <header class="nav-mobile__header">
                <slot name="header"></slot>
            </header>
            <div class="nav-mobile__content">
                <ul
                    v-show="navOpened"
                    ref="menuHeightStyle"
                    :class="[
                        'nav-mobile__list nav-mobile__list--1',
                        { 'nav-mobile__list--sub-opened' : navIndexOpened >= 0 }
                    ]"
                >
                    <li
                        :class="[
                            'nav-mobile__item nav-mobile__item--1',
                            {
                                'is-opened' : indexA == navIndexOpened,
                                'is-active' : itemA.active
                            }
                        ]"
                        v-for="(itemA, indexA) in list"
                        :key="indexA"
                    >
                        <a
                            :href="itemA.link"
                            @click="showChilds($event, indexA, itemA)"
                            :target="itemA.blank ? '_blank' : false"
                            :class="[
                                'nav-mobile__link nav-mobile__link--1',
                                { 'is-active' : itemA.active }
                            ]"
                        >
                            <span v-html="itemA.name"></span>
                            <z-icon
                                width="16"
                                height="16"
                                name="modal-arrow"
                                dir="right"
                                v-if="itemA.items && itemA.items.length"
                            ></z-icon>
                        </a>

                        <div class="nav-mobile__childs" v-if="itemA.items">
                            <div class="nav-mobile__inner" ref="menuHeight">
                                <div class="nav-mobile__childs-header">
                                    <div class="nav-mobile__close-wrapper">
                                        <button class="nav-mobile__close" @click.prevent="hideChilds(indexA)">
                                            <z-icon name="modal-arrow" dir="left" width="16px" height="16px"></z-icon>
                                            <span>{{ closeText }}</span>
                                        </button>
                                    </div>
                                    <a
                                        :href="itemA.link"
                                        :target="itemA.blank ? '_blank' : false"
                                        :class="[
                                            'nav-mobile__link nav-mobile__link--overview',
                                            { 'is-active' : checkOverviewActive(itemA.link) }
                                        ]"
                                    >
                                        <span v-html="itemA.name"></span>
                                    </a>
                                </div>

                                <ul class="nav-mobile__list nav-mobile__list--2">
                                    <li
                                        :class="[
                                            'nav-mobile__item nav-mobile__item--2',
                                            {
                                                'is-active' : itemB.active,
                                                'is-opened' : indexB == navChildsIndexOpened
                                            }
                                        ]"
                                        v-for="(itemB, indexB) in clearHide(itemA.items)"
                                        :key="indexB"
                                    >
                                        <a
                                            :href="itemB.link"
                                            :class="[
                                                'nav-mobile__link nav-mobile__link--2',
                                                { 'is-active' : itemB.active }
                                            ]"
                                            :target="itemB.blank ? '_blank' : false"
                                        >
                                            <span v-html="itemB.name"></span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <footer class="nav-mobile__footer">
                <div class="nav-mobile__footer-content">
                  <p><z-link :href="`/${this.$root.lang}/terms`">{{ text.terms }}</z-link></p>
                  <p><z-link :href="`/${this.$root.lang}/sitemap`">{{ text.sitemap }}</z-link></p>
                  <address v-html="text.adress">
                  </address>
                  <p class="nav-mobile__footer-contacts">{{ text.phone }} <z-link href="tel:+74999578659">+7(499) 957-86-59</z-link></p>
                  <p class="nav-mobile__footer-contacts">Email: <z-link href="mailto:sales@tcmstrade.ru">sales@tcmstrade.ru</z-link></p>
                  <p v-html="text.copyright"></p>
                </div>
            </footer>
        </div>
    </nav>
</template>

<script>
import { localize } from '@/utils/i18n'
import { mapActions } from 'vuex'

export default {
    name: 'navigation-mobile',
    data () {
        return {
            navOpened: false,
            navIndexOpened: -1,
            navChildsIndexOpened: -1,
            heightStyles: {},
            closeText: localize({
                ru: 'Главное меню',
                en: 'Main menu'
            }),
            text: {
                phone: localize({
                    ru: 'Телефон:',
                    en: 'Phone:'
                }),
                adress: localize({
                    ru: 'Адрес: 143401, Московская область, г.&nbsp;Красногорск, бульвар Строителей, д.&nbsp;4, корп.&nbsp;1, помещение&nbsp;IХ',
                    en: 'Adress: 143401, Krasnogorsk, 4&nbsp;Stroiteley Blvd, Bldg&nbsp;1, room&nbsp;IX'
                }),
                copyright: localize({
                    ru: '© ООО «ТК МС-Трейд», 2024',
                    en: '© 2024 TC MS-Trade'
                }),
                terms: localize({
                    ru: 'Условия использования',
                    en: 'Terms of use'
                }),
                sitemap: localize({
                    ru: 'Карта сайта',
                    en: 'Site Map'
                })
            }
        }
    },
    computed: {
        list () {
            if (!this.$root.app.components.navigation) return
            return this.$root.app.components.navigation.top
        },
        menuInvert () {
            return this.$store.getters.menuInvert
        }
    },
    updated () {
        this.matchHeight()
    },
    methods: {
        ...mapActions(['MenuOpen']),
        matchHeight () {
            if (this.navIndexOpened !== -1) {
                let heightString = this.$refs.menuHeight[this.navIndexOpened].clientHeight + 'px'
                this.$refs.menuHeightStyle.setAttribute('style', `min-height: ${heightString}`)
            } else {
                this.$refs.menuHeightStyle.setAttribute('style', ``)
            }
        },
        buildTarget (href) {
            return /^http|^\/\//.test(href) ? '_blank' : '_self'
        },
        isActive (path) {
            return window.location.pathname === path
        },
        checkOverviewActive (link) {
            return location.pathname === link
        },
        showChilds (event, i, item) {
            if (!item.hasOwnProperty('items')) {
                this.hideChilds()
            } else if (item.hasOwnProperty('items') && item.items.length && this.navIndexOpened !== i) {
                event.preventDefault()
                this.navIndexOpened = i
                this.navChildsIndexOpened = -1
            }
        },
        showSubChilds (event, i, item) {
            if (item.hasOwnProperty('items') && item.items.length && this.navChildsIndexOpened !== i) {
                event.preventDefault()
                this.navChildsIndexOpened = i
            }
        },
        hideChilds () {
            this.navIndexOpened = -1
            this.navChildsIndexOpened = -1
        },
        toggleNav () {
            if (!this.navOpened) {
                this.navOpened = true
                this.MenuOpen(true)
                document.body.style.overflow = 'hidden'
                this.$root.$bus.$emit('navigation-open')
                document.querySelector('body').classList.add('nav-opened')
            } else {
                this.navOpened = false
                this.MenuOpen(false)
                document.body.style.overflow = ''
                this.$root.$bus.$emit('navigation-close')
                document.querySelector('body').classList.remove('nav-opened')
            }
        },
        clearHide (data) {
            return data.filter(item => !item.hide)
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
